import axios from "../../../context/axiosConfig";

const pozyczkiDeleteActivePromissoryNote = async (loanId) => {
	return axios.post("/pozyczki/promissory/delete-active", {
		loanId,
	});
};

export default pozyczkiDeleteActivePromissoryNote;
